import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";
import Navigation from "../../common/components/Navigation/Navigation";

const ChatWrapper = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const isWixarpedia = location.pathname === "/chat/wixarpedia";

  return (
    <>
      <Navigation
        title={isWixarpedia ? t("pages.chat.tabs.wixarpedia") : t("pages.chat.title")}
        // Same line as the Wixarpédia card in Centre d'aide — one description of
        // the agent, shown at both entry points.
        subtitle={isWixarpedia ? t("pages.helpCenter.chatText") : undefined}
      />
      <Outlet />
    </>
  );
};

export default ChatWrapper;
